module.exports = __webpack_public_path__ + "files/mimoz.c8248829cbe6a562f165dbfe5ccc53f2.pdf";